import React from 'react';
import { ClientClipperFilterModel, clientClipperFilterModelInitial } from '../../../Models/ClientClipperFilterModel';
import { ClippingParameterModel } from '../../../Models/ClippingParameterModel';

export interface IClippingParametersContextProps {
    requiredClippingParameterError: boolean,
    setRequiredClippingParameterError: (value: boolean) => void,
    clippingParameterNotSelectedError: boolean,
    setClippingParameterNotSelectedError: (value: boolean) => void,
    clippingParameterValueNotDefinedError: boolean,
    setClippingParameterValueNotDefinedError: (value: boolean) => void,
    clippingParametersEditMode: boolean,
    setClippingParametersEditMode: (value: boolean) => void,
    currentClippingParameterIndex: number,
    setCurrentClippingParameterIndex: (value: number) => void,
    currentClientClipperFilter: ClientClipperFilterModel,
    setCurrentClientClipperFilter: (value: ClientClipperFilterModel) => void,
    currentClippingParameter: ClippingParameterModel | null,
    setCurrentClippingParameter: (value: ClippingParameterModel | null) => void,
}

export const ClippingParametersContextInitial: IClippingParametersContextProps = {
    requiredClippingParameterError: false,
    setRequiredClippingParameterError: () => { ''; },
    clippingParameterNotSelectedError: false,
    setClippingParameterNotSelectedError: () => { ''; },
    clippingParameterValueNotDefinedError: false,
    setClippingParameterValueNotDefinedError: () => { ''; },
    clippingParametersEditMode: false,
    setClippingParametersEditMode: () => { ''; },
    currentClippingParameterIndex: -1,
    setCurrentClippingParameterIndex: () => { ''; },
    currentClientClipperFilter: clientClipperFilterModelInitial,
    setCurrentClientClipperFilter: () => { ''; },
    currentClippingParameter: null,
    setCurrentClippingParameter: () => { ''; },
};

export const ClippingParametersContext = React.createContext(ClippingParametersContextInitial);
